import { defineCatalogue } from '../../../i18n';

const dataCatalogue = defineCatalogue(
  {
    nav: 'Dados',
    heading: 'Dados e privacidade',
    'retention.title': 'Retenção de dados',
    'retention.label': 'Retenção de dados após o fim da campanha',
    'retention.description':
      'Quando uma campanha termina, na data de término ou ao ser arquivada, os dados coletados para ela ficam guardados por este prazo e depois são apagados. Enquanto a campanha está ativa, nada é apagado. Mínimo de 30 dias; cada campanha pode definir o seu próprio prazo.',
    'unrelated.label': 'Retenção de publicações não relacionadas',
    'unrelated.description':
      'Publicações e stories das contas monitoradas que nenhuma campanha ativa considera relacionados são apagados, com suas mídias, depois deste prazo contado da coleta. Mínimo de 6 horas; cada campanha pode definir o seu próprio prazo.',
    'retention.save': 'Salvar',
    'processing.title': 'Tratamento de dados',
    'processing.body':
      'Dados públicos do Instagram; finalidade: análise; base legal: dados de acesso público; retenção: até o fim da campanha + {retention} (configurável); publicações não relacionadas a nenhuma campanha: {unrelated} após a coleta (configurável).',
  },
  {
    nav: 'Data',
    heading: 'Data and privacy',
    'retention.title': 'Data retention',
    'retention.label': 'Data retention after the campaign ends',
    'retention.description':
      'When a campaign ends, on its end date or when it is archived, the data collected for it is kept for this period and then deleted. Nothing is deleted while the campaign is active. At least 30 days; each campaign can set its own period.',
    'unrelated.label': 'Retention of unrelated posts',
    'unrelated.description':
      'Posts and stories from tracked accounts that no active campaign reads as related are deleted, with their media, this long after they were collected. At least 6 hours; each campaign can set its own period.',
    'retention.save': 'Save',
    'processing.title': 'Data processing',
    'processing.body':
      'Public Instagram data; purpose: analytics; legal basis: publicly accessible data; retention: until the campaign ends + {retention} (configurable); posts related to no campaign: {unrelated} after collection (configurable).',
  },
);

export const dt = dataCatalogue.t;
